var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_404"},[_c('h2',{staticClass:"m-0"},[_vm._v("抱歉，页面未找到，"),_c('span',[_vm._v(_vm._s(_vm.countDown))]),_vm._v("s后自动跳转到 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.goBack}},[_vm._v("上一页")])]),_c('img',{attrs:{"src":require("./images/404.png"),"alt":"页面未找到"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }